// =====================================================================
//  Conversiones de Google Ads con protección anti-duplicados / anti-bots.
//  - Un mismo evento (clave) se cuenta UNA sola vez por navegador.
//  - Se ignoran navegadores automatizados (navigator.webdriver) y pestañas
//    ocultas (prerender / bots que no renderizan la página).
//  - Se envía transaction_id para que Google deduplique en su lado.
// =====================================================================

const looksAutomated = () => {
  try {
    if (navigator.webdriver) return true;
    if (document.visibilityState === "hidden") return true;
  } catch { /* sin navigator: no bloquear */ }
  return false;
};

// Dispara la conversión `sendTo` solo si no se contó antes la misma `key`.
// Devuelve true si se envió.
export function fireAdsConversion(sendTo, key, params = {}) {
  if (typeof window === "undefined" || !window.gtag || !sendTo) return false;
  if (looksAutomated()) return false;
  const storeKey = `_aw_fired_${sendTo}_${key}`;
  try {
    if (localStorage.getItem(storeKey)) return false;
    localStorage.setItem(storeKey, "1");
  } catch { /* storage bloqueado: se envía igual */ }
  window.gtag("event", "conversion", { send_to: sendTo, transaction_id: String(key), ...params });
  return true;
}